import {loginApi} from "@/api/authApi";
import {getToken, setToken, clearToken, getStoredUsername, setStoredUsername, clearStoredUsername} from "@/utils/auth";

export default {
    namespaced: true,
    state () {
        return {
            token: getToken(),
            username: getStoredUsername()
        }
    },
    mutations: {
        setAuth (state, {token, username}) {
            state.token = token
            state.username = username
        },
        clearAuth (state) {
            state.token = ''
            state.username = ''
        }
    },
    actions: {
        async loginAction (context, {username, password}) {
            const res = await loginApi(username, password)
            setToken(res.data.token)
            setStoredUsername(res.data.username)
            context.commit('setAuth', {token: res.data.token, username: res.data.username})
        },
        logoutAction (context) {
            clearToken()
            clearStoredUsername()
            context.commit('clearAuth')
        }
    },
    getters: {
        isLoggedIn: state => !!state.token,
        username: state => state.username
    }
}
